import React from 'react';
import { FrontPage } from 'cvs-core';
import menuLogo from '../../assets/images/Vape-Free-Reverse-Text-Red-X Copy@2x.jpg';
import foregroundImg from '../../assets/images/hmpg.png';
// import backgroundImg from '../../assets/images/hmpg@2x.png';

// const foregroundImg = 'http://via.placeholder.com/200x150';

const data = {
  title: 'Don’t Let Vaping Cloud the Facts',
  subTitle: '',
  intro: (
    <p>
      Check out these videos to separate myth from fact and uncover how vaping and e-cigarette use may affect your mental health, physical health and overall well-being.
    </p>
  ),
  logo: menuLogo,
  foregroundImg,
  // backgroundImg
};

export default {
  title: 'Welcome',
  path: '/',
  content: <FrontPage data={data} />
};



// WEBPACK FOOTER //
// ./src/data/home/index.js